export default __webpack_public_path__ + "static/media/signup.5d822718.jpg";